import { Link } from "react-router-dom";
import { ExternalLink, Layers, Users } from "lucide-react";
import { useCatalog } from "@/context/CatalogContext";

/**
 * Contrato de módulos e usuários da empresa ficam na Central Administrativa
 * (fonte única). Esta aba substitui as antigas Módulos/Usuários/Delegações,
 * que duplicavam aquelas telas (e a de Módulos regravava o mapa completo).
 */
export default function AccessTab({ clientId }) {
  const { isAvailable } = useCatalog();
  const links = [
    isAvailable("empresas") && {
      to: `/admin/empresas/${clientId}?tab=contrato`,
      icon: Layers,
      title: "Contrato de módulos",
      text: "Módulos contratados pela empresa, recursos complementares e histórico de alterações.",
      testId: "client-access-contract",
    },
    isAvailable("gestao_acessos") && {
      to: `/admin/usuarios?empresa=${clientId}`,
      icon: Users,
      title: "Usuários e acessos",
      text: "Usuários vinculados, perfis, unidades, módulos e ações concedidas ou revogadas.",
      testId: "client-access-users",
    },
  ].filter(Boolean);

  if (!links.length) {
    return <p className="text-sm text-muted-foreground">Seu perfil não administra contrato nem usuários desta empresa.</p>;
  }
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="client-access-tab">
      {links.map(({ to, icon: Icon, title, text, testId }) => (
        <Link key={to} to={to} className="rounded-lg border border-border p-4 transition-colors hover:border-primary/50 hover:bg-accent/40" data-testid={testId}>
          <p className="flex items-center gap-2 text-sm font-semibold">
            <Icon size={16} className="text-primary" aria-hidden="true" /> {title}
            <ExternalLink size={12} className="text-muted-foreground" aria-hidden="true" />
          </p>
          <p className="mt-1 text-xs text-muted-foreground">{text}</p>
        </Link>
      ))}
    </div>
  );
}
